import { useRef, useState } from "react";
import ContactFormWizard from "components/ContactFormWizard";
import ContactFormWizardPreview from "components/ContactFormWizard/ContactFormWizardPreview";
import PublishLeftPanel from "./PublishLeftPanel";
import SafeEnvelopeLeftPanel from "./SafeEnvelopeLeftPanel";
import workspaceService from "api/workspaceService";
import { IWorkspace, IWorkspaceMember } from "dto/IWorkspace";
import { getCompanyId as getWorkspaceId } from "utils/getCompanyId";
import {
  DEFAULT_WIZARD_SETTINGS,
  EWizardStep,
  IContactFormWizardSettings,
  WizardSettingsPatch,
} from "components/ContactFormWizard/typings";
import styles from "./styles.module.scss";

const ESzyfrowaneTab = () => {
  const [eszyfSettings, setEszyfSettings] =
    useState<IContactFormWizardSettings>(DEFAULT_WIZARD_SETTINGS);
  const [eszyfStep, setEszyfStep] = useState<EWizardStep>(
    EWizardStep.FormStyle,
  );
  const [expandedStep, setExpandedStep] = useState<EWizardStep | null>(null);
  const workspaceId = getWorkspaceId() ?? "";
  const { data: workspaceData } = workspaceService.useGetWorkspace(workspaceId);
  const eszyfMembers: IWorkspaceMember[] =
    ((workspaceData?.data as IWorkspace)?.Members) ?? [];

  const patchSettingsRef = useRef<(patch: WizardSettingsPatch) => void>(() => {});
  const finishRef = useRef<() => void>(() => {});

  const goBackFromPublish = () => setEszyfStep(EWizardStep.FormStyle);

  const isCollapsed = expandedStep === null;
  const isPublishStep = expandedStep === EWizardStep.Publish;
  const isSafeEnvelopeStep = expandedStep === EWizardStep.SafeEnvelope;

  return (
    <div className={styles.root}>
      <div className={styles.hint}>
        W tej zakładce konfigurujesz opcje nadawania i odbierania przesyłek eSzyfrowanych.
        Masz 3 opcje nadawania przesyłek szyfrowanych: formularz nadawczy bezpośrednio na Twojej
        stronie www, nadawanie przy pomocy tak zwanej Bezpiecznej Koperty, nadawanie ze strony
        eSzyfrowane.pl.{" "}
        Zdecyduj też kto i jak w Twojej firmie będzie odbierał przesyłki eSzyfrowane. Wszystko
        po to, aby Twoi kontrahenci mogli bezpiecznie i poufnie przesyłać do Ciebie wrażliwą
        korespondencję.
      </div>
      <div className={styles.layout}>
        <div className={styles.left}>
          {isCollapsed ? (
            <div className={styles.placeholder}>
              <div className={styles.placeholderIcon}>🔒</div>
              <div className={styles.placeholderText}>
                <h3>Przesyłki eSzyfrowane</h3>
                <p>Plansza z grafiką objaśniająca ideę<br />zaszyfrowanej wymiany dokumentów</p>
              </div>
              <div className={styles.placeholderBadge}>do wykonania</div>
            </div>
          ) : isPublishStep ? (
            <PublishLeftPanel
              settings={eszyfSettings}
              patchSettingsRef={patchSettingsRef}
              finishRef={finishRef}
              onGoBack={goBackFromPublish}
            />
          ) : isSafeEnvelopeStep ? (
            <SafeEnvelopeLeftPanel
              settings={eszyfSettings}
              patchSettingsRef={patchSettingsRef}
            />
          ) : (
            <ContactFormWizardPreview
              settings={eszyfSettings}
              members={eszyfMembers}
              activeStep={eszyfStep}
            />
          )}
        </div>
        <div className={styles.right}>
          <ContactFormWizard
            inline
            startCollapsed
            initialSettings={{ WorkspaceId: workspaceId || undefined }}
            members={eszyfMembers}
            onSettingsChange={setEszyfSettings}
            onStepChange={setEszyfStep}
            onExpandedStepChange={setExpandedStep}
            onClose={() => {}}
            patchSettingsRef={patchSettingsRef}
            finishRef={finishRef}
          />
        </div>
      </div>
    </div>
  );
};

export default ESzyfrowaneTab;
